module.exports = {
  BackToMain: 'Back to Main Page',
  UserInfo: 'My Account',
  Individual: 'Color Setting',
  Cache: 'Cache',
  Authorize: 'Authorize',
  CNName: 'Chinese Name:',
  Phone: 'Phone:',
  ENName: 'English:',
  Tel: 'TEL:',
  Email: 'Email:',
  QQ: 'QQ:',
  MyInfo: 'My Information',
  PersonalEmailSettings: 'Personal email settings',
  EmailPassword: 'Email Password/Authorization Code:',
  SignatureSetup: 'Signature Setup',
  ToEnableTheSignature: 'To enable the signature',
  SendTest: 'Send test',
  Edit: 'EDIT',
  Save: 'SAVE',
  Cancel: 'CANCEL',
  ChangePsd: 'Change Password',
  ErrorRaised: 'Error raised.',
  SaveSucceed: 'Save Succeed.',
  ResetJobCopySucceed: 'Page copy conditions can be reset',
  CancelChange: 'Are you really want to cancel the edit?',
  Name: 'Name',
  Version: 'Version',
  Amount: 'Amount',
  Filter: 'Filter:',
  RefreshCache: 'REFRESH',
  ResetCache: 'RESET',
  Refresh: 'REFRESH',
  Reset: 'RESET',
  Detail: 'DETAILS',
  UserName: 'User Name',
  LoginTime: 'Login Time',
  ExitTime: 'Exit Time',
  BackToMyAccount: 'Back to My Account',
  AuthHistory: 'History of Authorize',
  User: 'User',
  company: 'Company',
  platformId: 'Platform ID',
  department: 'Department',
  NewAuth: 'New Authorize',
  BeginDate: 'Valid From',
  EndDate: 'Valid Until',
  CancalAuth: 'CANCEL',
  UseAuth: 'Go to the Authorize Account',
  AuthOwned: 'All my Authorize ',
  ConfirmAuth: 'Confirm Authorize',
  InputAuthReason: 'Please enter the authorization reason',
  AuthFail: 'Authorize fail',
  AdminUse: ' ',
  InvalidUser: 'Pls select the user and period.',
  AuthMyself: 'It is unnecessary to authorize to yourself.',
  InputUser: 'Pls input a user name that you want authorize.',
  Tips: 'Tips',
  SaveYourChange: 'You must save your changes before back to your account.',
  ShutModule: 'There is(are) {0} module(s) open,do you want to shut down all of them?',
  LoginMySelf: 'It is unnecessary to login your account.',
  SelectAccout: 'Pls select a account.',
  TableColor: 'Table color',
  StatusName: 'Status name',
  ColorValue: 'Color value',
  PartnerDisplayControl: 'Data display control',
  PartnerCategory: 'Data category',
  Chinese: 'Chinese',
  English: 'English',
  Code: 'Code',
  EnglishAndChinese: 'English+Chinese',
  ChineseAndEnglish: 'Chinese+English',
  ShortName: 'ShortName',
  CodeAndChinese: 'Code+Chinese',
  CodeAndEnglish: 'Code+English',
  ShortNameAndChinese: 'ShortName+Chinese',
  YouDoNotHaveAccessToTheAdministratorAccount: 'You do not have access to the administrator account.',
  Setting: 'Setting',
  VerificationSettings: 'Verify Pop-up Settings',
  ResetJobCopyTittle: 'Reset page conditions',
  ResetJobCopyMessage: 'After clicking the setting button, the copy condition setting dialog box will be displayed again when copying, and the copy conditions can be set again',
  RepeatCopyMessage: 'The same charges name already exists, copy again?',
  WeChatPushRemindTitle: 'Please scan the following QR code and follow the "WallTech Information" official account',
  WeChatPushRemind1: 'Please make sure that you have followed the "WallTech Information" official account, otherwise you will not be able to receive WeChat messages.',
  WeChatPushRemind2: 'There may be a delay in WeChat push, and all information is subject to the display on the web terminal.',
  IveFollowed: 'I\'ve followed',
  CheckedCategory: 'Tick option category',
  AfterCheckedSelection: 'After clicking the reset button, the agent selection page will be displayed again when applying for insurance, and the agent options can be reset',
  FreightInsuranceProvider: 'Freight Insurance Service Provider',
  ResetFreightInsuranceProvider: 'Reset Freight Insurance Service Provider',
  FreightInsuranceProviderReset: 'Freight Insurance Service Provider Options Have Been Reset',
  CopyBusiness: 'Copy Business',
  UseSsl: 'To enable SSL',
  Japanese: 'Japanese',
  CustomerSupplierNoChinese: 'customer no/supplier no + chinese',
  threeCharacterCode: 'ShortName + Three character code',
  threeCharacterCodeTooltip: 'Three character code: MAWB Prefix',
  CustomerNoChinese: 'customer no + chinese',
  SupplierNoChinese: 'supplier no + chinese',
  pageDisplay: 'Page Display',
  required: 'Required',
  b2bWebsite: 'B2B Website',
  b2bWebsiteDisplay: 'B2B Website Display'
}
